import { getRequestQueryKey } from '../../hooks/use_suspense_api'
import { getMessageFields, getMessagesInclude } from './messages_data_options'

export const getMessageRequestArgs = ({
  conversation_id,
  messageId,
}: {
  conversation_id: number
  messageId: string
}) => {
  const url = `/me/conversations/${conversation_id}/messages/${messageId}`

  return {
    url,
    data: {
      perPage: 25,
      fields: getMessageFields,
      include: getMessagesInclude,
    },
  }
}

export const getMessageQueryKey = ({
  conversation_id,
  messageId,
}: {
  conversation_id: number
  messageId: string
}) => {
  const requestArgs = getMessageRequestArgs({ conversation_id, messageId })
  return getRequestQueryKey(requestArgs)
}
